module.exports = __webpack_public_path__ + "static/media/searcy2.34ec5213.jpg";